// src/components/marketplace/FilterControls.tsx

import React from 'react';
// REMOVED: useTranslation is no longer needed.
import { Button } from '@dopomogai/ui';

interface FilterControlsProps {
  // UPDATED: Now expects the fully translated list of categories.
  categories: string[];
  activeCategory: string;
  onFilterChange: (category: string) => void;
}

export const FilterControls: React.FC<FilterControlsProps> = ({ categories, activeCategory, onFilterChange }) => {
  // REMOVED: The logic to get `t` and prepend the "All" filter is now handled by the parent page.

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-12">
      {/* The component simply maps over the provided list of strings. */}
      {categories.map(category => (
        <Button
          key={category}
          text={category}
          variant={activeCategory === category ? 'primary' : 'secondary'}
          onClick={() => onFilterChange(category)}
          className={activeCategory === category ? '' : 'bg-white hover:bg-slate-50'}
        />
      ))}
    </div>
  );
};